import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as service from '../services';
import { useManageComercialTableStore } from '../ManageComercialTable.store';
import { handleDateFormat } from '../../../utils';
import { AtivarPromoDataTypes } from '../types';
import { NotificationMessage } from '../../../../../../components';

interface ErrorResponse {
  status: number;
  [key: string]: any;
}

interface ErrorActionArg {
  response: ErrorResponse | undefined;
}

type ResponseData = { mensagem?: string }[];

export const useAtivarOferta = () => {
  const queryClient = useQueryClient();

  const { ativarPromoData, setOpenModalActivateProductOffer, setManageComercialTableState } = useManageComercialTableStore();

  const STATUS_400 = (responseData: ResponseData) => {
    const mensagemBruta = responseData?.[0]?.mensagem || 'Erro desconhecido';
    const mensagemTratada = mensagemBruta.replace(/IllegalArgumentException:\s*/, '');
    NotificationMessage('error', 7000, mensagemTratada);
  };

  const successAction = () => {
    queryClient.invalidateQueries(['comercial-table-product-list']);
    queryClient.invalidateQueries(['edit-comercial-table-list']);
    setOpenModalActivateProductOffer(false, false, null);
  };

  const errorAction = (data: ErrorActionArg) => {
    if (data.response && data.response.status === 400) {
      STATUS_400(data.response.data as ResponseData);
    }
  };

  const ativarOfertaMutation = useMutation({
    mutationFn: (payload: AtivarPromoDataTypes) => service.saveOfertaPromo(payload),
    onSuccess: successAction,
    onError: errorAction,
  });

  const cancelarOfertaMutation = useMutation({
    mutationFn: (payload: number) => service.cancelOfertaPromo(payload),
    onSuccess: successAction,
  });

  const handleClickAtivarPromo = () => {
    const promoData = {
      ...ativarPromoData,
      inicioVigencia: ativarPromoData.inicioVigencia,
      terminoVigencia: ativarPromoData.terminoVigencia,
    };
    ativarOfertaMutation.mutateAsync(promoData);
  };

  const handleClickCancelarPromo = () => {
    cancelarOfertaMutation.mutateAsync(ativarPromoData.idRascunhoProduto);
  };

  const handleBlurPrecoOferta = (value: string | undefined) => {
    const price = { ...ativarPromoData, precoOferta: Number(value?.replace(',', '.')) };
    setManageComercialTableState('ativarPromoData', price);
  };

  const handleChangeDateVigencia = (dateType: string, value: string) => {
    const price = { ...ativarPromoData, [dateType]: handleDateFormat(value) };
    setManageComercialTableState('ativarPromoData', price);
  };

  return {
    handleClickAtivarPromo,
    handleClickCancelarPromo,
    handleBlurPrecoOferta,
    handleChangeDateVigencia,
  };
};
